import { render } from "./SettingsNavigation.vue?vue&type=template&id=6768bd86"
import script from "./SettingsNavigation.vue?vue&type=script&lang=js"
export * from "./SettingsNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__